import { AsyncPropSelector, ApiProgressLoader } from '@nile/components';
import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  Button,
  ButtonGroup,
  Popover,
  TextField
} from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
  padding-left: 8px;
  padding-right: 8px;
  max-width: 100%;
  width: 100%;
  white-space: break-spaces;
`;
function TextCell(props) {
  const { cell, params, _ticket } = props;
  const allProps = params || cell.column;
  const { editable, field, actions, accessor, entity, editMode } = allProps;
  const ticket = _ticket || cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const [apiProgress, setApiProgress] = useState(false);
  const [apiResult, setApiResult] = useState('');
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        case 'sop':
          serialisedValue = { sopId: val.sopId, name: val.name };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const setApiComplete = (state) => {
    if (props.showProgress) {
      setApiProgress(false);
      setApiResult(state);
    }
    setTimeout(() => {
      setApiResult('');
    }, 2000);
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? typeof fieldValue === 'object'
        ? {
            name: fieldValue.name,
            label: fieldValue.name,
            value: fieldValue.name
          }
        : { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <div className="min-w-200 max-w-250 fg1 pr10 pl10 mt-8 mb8 ">
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
          entity={entity || 'Ticket'}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                if (props.showProgress) {
                  setApiProgress(true);
                }
                actions.save &&
                  actions.save(
                    updatedProperties,
                    ticket,
                    props.data,
                    setApiComplete
                  );
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  };

  const renderValue = (displayVal, suffix) => {
    const updatedDisplayVal = `${displayVal}${suffix || ''}`;
    if (field?.name === 'requester' && ticket?.source === 'Agent') {
      return 'System';
    }
    if (cell?.column?.isBold) {
      return <b>{updatedDisplayVal}</b>;
    }
    return updatedDisplayVal;
  };
  //TODO :: render value in a proper way for NA - vignesh
  const displayVal = cell
    ? props.column.subAccessor
      ? cell.value[props.column.subAccessor]
      : cell.value
      ? cell.value.name || cell.value
      : ''
    : ticket[accessor]
    ? typeof ticket[accessor] === 'object'
      ? ticket[accessor].name
        ? ticket[accessor].name
        : ticket[accessor].firstName
        ? ticket[accessor].firstName + ' ' + ticket[accessor].lastName
        : ticket[accessor].label
      : ticket[accessor]
    : '';

  return (
    <Wrap className={`cell`}>
      {editable && editMode ? (
        <TextField
          id="ticketStatusDescription"
          value={displayVal}
          multiline
          onChange={(val) => {
            actions.onChange({
              key: 'details',
              value: val,
              field: cell.row.original
            });
          }}
          type="text"
        />
      ) : (
        <div className={``} title={displayVal}>
          {displayVal ? (
            renderValue(displayVal, cell?.column?.suffix)
          ) : (
            <DisabledTag>NA</DisabledTag>
          )}
        </div>
      )}
    </Wrap>
  );
}

export default TextCell;
